// Mock data for Expert Roofing website

export const companyInfo = {
  name: "Expert Roofing",
  logo: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/qo1tzfs6_f67638a2-6fbb-45e3-820a-734911a6b173.jpg",
  phone: "425-499-4713",
  email: "expertroofingwa@gmail.com",
  instagram: "expertroofingwa",
  instagramUrl: "https://www.instagram.com/expertroofingwa",
  address: "912 152nd Pl SW, Lynnwood, WA 98087",
  manager: "Thyago Silva",
  availability: "24/7 Emergency Service",
};

export const services = [
  {
    id: 1,
    title: "Roof Replacement",
    description: "Complete roof replacement with high-quality materials and expert craftsmanship. We ensure your new roof protects your home for decades.",
    icon: "Home",
    image: "https://images.pexels.com/photos/31771166/pexels-photo-31771166.jpeg"
  },
  {
    id: 2,
    title: "New Construction",
    description: "Professional roofing installation for new construction projects. We work with builders and homeowners to deliver excellence.",
    icon: "Building",
    image: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e"
  },
  {
    id: 3,
    title: "Roof Repair",
    description: "Fast and reliable roof repair services. From minor leaks to major damage, we fix it right the first time.",
    icon: "Wrench",
    image: "https://images.pexels.com/photos/7788264/pexels-photo-7788264.jpeg"
  }
];

export const beforeAfterGallery = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1635424709961-f3a150459ad4",
    after: "https://images.pexels.com/photos/31771166/pexels-photo-31771166.jpeg",
    title: "Complete Roof Replacement",
    description: "Transformed this aging roof into a beautiful, durable new installation."
  },
  {
    id: 2,
    before: "https://images.pexels.com/photos/9875418/pexels-photo-9875418.jpeg",
    after: "https://images.pexels.com/photos/8853468/pexels-photo-8853468.jpeg",
    title: "Emergency Leak Repair",
    description: "Fixed critical leaks and restored complete protection."
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2",
    after: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e",
    title: "New Construction Project",
    description: "Professional installation for new home construction."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John M.",
    location: "Lynnwood, WA",
    rating: 5,
    text: "Expert Roofing did an amazing job on our roof replacement. Thyago and his team were professional, punctual, and the quality is outstanding!"
  },
  {
    id: 2,
    name: "Sarah K.",
    location: "Everett, WA",
    rating: 5,
    text: "Had an emergency leak at 2 AM and they came out immediately. Saved our home from major water damage. Highly recommend their 24/7 service!"
  },
  {
    id: 3,
    name: "Mike R.",
    location: "Seattle, WA",
    rating: 5,
    text: "The free estimate was detailed and fair. The work was completed on time and looks fantastic. Best roofing company in the area!"
  }
];

export const features = [
  {
    id: 1,
    title: "24/7 Emergency Service",
    description: "Roof leaks don't wait for business hours. Call us anytime, day or night.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Free Estimates",
    description: "Get a detailed, no-obligation estimate for your roofing project.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Expert Craftsmanship",
    description: "Years of experience delivering quality roofing solutions.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Licensed & Insured",
    description: "Fully licensed and insured for your peace of mind.",
    icon: "Shield"
  }
];

// Real portfolio images from completed projects
export const portfolioImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/qzj08sde_d7ae2dec-cb64-4684-b589-17d06a732aa6.jpg",
    title: "Residential Roof Replacement",
    category: "Replacement"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/lfq739kl_dab6ff0c-8d05-4061-8e38-37a4528a62c8.jpg",
    title: "Complete Roof Installation",
    category: "New Construction"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/n0pnoc55_2433785c-7dcf-4256-834e-39a2a44e8ed0.jpg",
    title: "Quality Shingle Roofing",
    category: "Replacement"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/0a3hbxyp_e3fc823f-ff86-400f-aaec-a16efb312832.jpg",
    title: "Roof Reconstruction Project",
    category: "New Construction"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/ta146jfn_3cfe8f2a-cabc-4016-8cca-4b060be36301.jpg",
    title: "Sunset View - Completed Work",
    category: "Replacement"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/xskic11a_7c2a66ec-1fc0-47a3-a928-3b9d6ff69baa.jpg",
    title: "Skylight Installation - Metal Roofing",
    category: "New Construction"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/ba7b05ze_d2b8209a-b488-4b41-8891-9eeb4b450777.jpg",
    title: "Modern Roof with Skylights",
    category: "New Construction"
  }
];

// Transformation showcase - Before, During, After
export const transformationProject = {
  title: "Complete Roof Transformation",
  description: "Follow each stage of our professional process",
  location: "Lynnwood, WA",
  duration: "3 days",
  phases: [
    {
      id: 1,
      stage: "BEFORE",
      image: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/6qbsrfu1_3f7dd4fb-c58a-4aa3-86e6-7f6061d62010.jpg",
      description: "Old roof with severe damage requiring complete replacement"
    },
    {
      id: 2,
      stage: "DURING",
      image: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/1vd8yner_26e42c8a-4d70-488f-b10e-b0b44a003d57.jpg",
      description: "Our team working on installing the new roofing system"
    },
    {
      id: 3,
      stage: "AFTER",
      image: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/8sjg6mr2_32bc7d34-55b8-4989-8253-2460fef954bd.jpg",
      description: "Completely renovated roof with quality guarantee"
    }
  ]
};

// Before & After Comparison - Featured Projects
export const beforeAfterProjects = [
  {
    id: 1,
    title: "Complete Roof Transformation",
    subtitle: "Premium Quality Upgrade",
    description: "Drag the slider to see how we transformed this roof from worn and weathered to beautiful and protected.",
    location: "Lynnwood, WA",
    beforeImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/zbk43d0o_cbdb243d-a860-4e5f-a62c-a3ea539bdbf6.jpg",
    afterImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/nnp4lov6_cd7a2a27-2034-446a-99a4-d045158c014d.jpg",
    features: [
      "Complete roof replacement",
      "Premium quality shingles",
      "Enhanced curb appeal",
      "Long-lasting protection"
    ]
  },
  {
    id: 2,
    title: "Modern Roof Renovation",
    subtitle: "From Damaged to Perfect",
    description: "Drag the slider to see the dramatic transformation from a damaged roof with tarps to a stunning new installation.",
    location: "Lynnwood, WA",
    beforeImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/sgmc8skc_04df975b-45f4-4cb9-a321-2350b4d87110.jpg",
    afterImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/ogvjpc4r_90fd6e15-2a71-45b2-98be-2ac2eaac01ee.jpg",
    features: [
      "Emergency roof repair",
      "High-quality materials",
      "Professional installation",
      "Improved home value"
    ]
  },
  {
    id: 3,
    title: "Luxury Home Roof Upgrade",
    subtitle: "Premium Transformation",
    description: "Drag the slider to see the stunning upgrade from weathered brown shingles to elegant dark gray roofing.",
    location: "Lynnwood, WA",
    beforeImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/i5tila26_35924b38-9667-4b09-848b-6288e77280f3.jpg",
    afterImage: "https://customer-assets.emergentagent.com/job_lynnwood-roofing/artifacts/9xpmchti_76613af3-3a1c-47d2-b58b-b08a7d42458a.jpg",
    features: [
      "Complete roof renovation",
      "Modern color upgrade",
      "Superior weather protection",
      "Increased property value"
    ]
  }
];
